// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"655":"bd3d3bbd","699":"b0a93580"}[chunkId] + ".chunk.js";
};